export default "__VITE_ASSET__GsoJB1Ks__"